import htmx from 'htmx.org';
import * as uuid from 'uuid';
import * as webVitals from 'web-vitals';

// Legacy scripts and inline handlers use these globals.
Object.assign(window, { htmx, uuid, webVitals });
htmx.config.methodsThatUseUrlParams = ['get'];
